import React from "react";
import { useLocation } from "react-router-dom";
import MobileBottomTabBar from "./MobileBottomTabBar";

/**
 * Globally-mounted wrapper around the MobileBottomTabBar.
 *
 * Mounted ONCE at the App.js root (inside <BrowserRouter>) so every
 * route inherits the tab bar without each page having to opt in.
 * Uses `useLocation()` to hide itself on routes where the bar would
 * be intrusive:
 *   • `/chat/:chatId` — the 1:1 chat window; the bar would sit right
 *     on top of the message input on mobile.
 *   • Any future route that starts with `/chat/` (call windows,
 *     voice channels) inherits the same rule.
 *
 * This is a self-contained gatekeeper so page authors never need to
 * remember to conditionally render or hide the bar — they get it for
 * free, and the exclusions live in ONE place.
 */
const HIDE_ON_PREFIXES = [
  "/chat/",       // 1:1 astrologer chat window
  "/voice-call/", // active voice-call screen (if/when we add one)
  "/visualise",   // cosmic-intro splash before /astro-visualization
  "/wallet/topup",// wallet top-up amount picker + payment info — focus mode
];

export default function GlobalMobileTabBar() {
  const { pathname } = useLocation();
  const shouldHide = HIDE_ON_PREFIXES.some((p) => pathname.startsWith(p));
  if (shouldHide) return null;
  return <MobileBottomTabBar />;
}
